var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteMembers = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/members") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/members",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Name",
    transform: "translate(3.3334, 5)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.728723,0 C17.4883074,0 19.7253925,2.1935934 19.7253925,4.89952798 C19.7253925,7.60546257 17.4883074,9.79905597 14.728723,9.79905597 C14.0865436,9.79905597 13.4726593,9.68026552 12.9086772,9.46387171 C14.7700429,8.75037428 16.0870952,6.97576796 16.0870952,4.89952798 C16.0870952,2.82328801 14.7700429,1.04868168 12.9104715,0.335184258 C13.4726593,0.118790443 14.0865436,0 14.728723,0 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    cx: 9.27127704,
    cy: 4.89952798,
    rx: 4.99666956,
    ry: 4.89952798
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2812684,11.200944 C21.4439003,11.200944 24,13.70735 24,16.8226568 L24,20.3061362 C24,20.6884693 23.6822927,21 23.2923792,21 L19.6540819,21 C20.0439954,21 20.3617027,20.6884693 20.3617027,20.3061362 L20.3617027,16.8226568 C20.3617027,13.70735 17.805603,11.200944 14.6429711,11.200944 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8238225,11.200944 L5.73317288,11.200944 C2.57054099,11.200944 0,13.7215105 0,16.8226568 L0,20.3061362 C0,20.6884693 0.317707313,21 0.707620833,21 L17.8349333,21 C18.2248468,21 18.5425541,20.6884693 18.5425541,20.3061362 L18.5425541,16.8226568 C18.5425541,13.70735 15.9864543,11.200944 12.8238225,11.200944 L12.8238225,11.200944 Z",
    id: "Path-Copy-3"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteMembers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-members.c150095aaf567374f82f80d0713d0f87.svg";